/**
 * Image path
 * @param imageTitle a string containing the title of the image
 * @returns the full URL of the image
 */
export const getFullImagePath = (imageTitle: string): string => {
  const urlWithoutApi = process.env.REACT_APP_BASE_URL?.replace('/api', '');
  return `${urlWithoutApi}/${imageTitle}`;
};
